module.exports = __webpack_public_path__ + "img/online.fc137876.png";